import React, { FC, useState } from 'react';
import { Column } from '@ant-design/charts';
import { Card, Checkbox, Col, Radio, Row, Space } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import { useTranslation } from 'react-i18next';

import { byDay, byMonth, byWeek, getDataset } from './getRandomSales';
import theme from '~/theme';
import constants from '~/utils/constants';

const purchaseDataset = getDataset({ name: 'Purchase', minValue: 500 });
// const cashDepositDataset = getDataset('Cash deposit');
// const cashWithdrawalDataset = getDataset('Cash withdrawal');
const reversalDataset = getDataset({ name: 'Reversal', multiplier: 100 });

const DemoColumn: FC = () => {
  const [t] = useTranslation();
  const options = [
    { label: t('transactions:PURCHASE'), value: 'purchaseDataset' },
    // { label: t('transactions:CASH_DEPOSIT'), value: 'cashDepositDataset' },
    // { label: t('transactions:CASH_WITHDRAWAL'), value: 'cashWithdrawalDataset' },
    { label: t('transactions:REVERSAL'), value: 'reversalDataset' },
  ];
  const discretenessOptions = [
    { label: t('day'), value: 'byDay' },
    { label: t('week'), value: 'byWeek' },
    { label: t('month'), value: 'byMonth' },
  ];

  const [operation, setOperation] = useState([options[0].value, options[1].value]);
  const onOperationChange = (checkedValues: any[]) => {
    setOperation(checkedValues);
  };

  const [discretenessName, setDiscretenessName] = useState<keyof typeof discreteness>(
    Object.keys(discreteness)[0] as any
  );
  const onDiscretenessChange = (e: RadioChangeEvent) => {
    setDiscretenessName(e.target.value);
  };

  const getData = () => {
    let result: any[] = [];
    const discretenessFunction = discreteness[discretenessName];
    if (operation.find((item) => item === 'purchaseDataset')) {
      result = result.concat(discretenessFunction(purchaseDataset));
    }
    // if (operation.find((item) => item === 'cashDepositDataset')) {
    //   result = result.concat(discretenessFunction(cashDepositDataset));
    // }
    // if (operation.find((item) => item === 'cashWithdrawalDataset')) {
    //   result = result.concat(discretenessFunction(cashWithdrawalDataset));
    // }
    if (operation.find((item) => item === 'reversalDataset')) {
      result = result.concat(discretenessFunction(reversalDataset));
    }
    return result;
  };

  const config = {
    data: getData(),
    isGroup: true,
    xField: 'date',
    yField: 'value',
    seriesField: 'name',
    label: {
      layout: [
        { type: 'interval-adjust-position' },
        { type: 'interval-hide-overlap' },
        { type: 'adjust-color' },
      ],
    },
    slider: {
      start: discretenessName === 'byDay' ? 0.85 : 0,
      end: 1,
    },
    legend: {
      position: 'bottom' as any,
    },
    color: [
      constants.balanceColorAvailable,
      constants.balanceColorPosted,
      constants.balanceColorPending,
      theme.primaryColor,
    ],
  };

  return (
    <Card title={t('columnChartTitle')}>
      <Space direction="vertical" style={{ width: '100%' }} size={20}>
        <Row align="middle" justify="space-between">
          <Col>
            <Checkbox.Group options={options} value={operation} onChange={onOperationChange} />
          </Col>
          <Col>
            <span style={{ marginRight: 8 }}>{t('per')}:</span>
            <Radio.Group
              options={discretenessOptions}
              onChange={onDiscretenessChange}
              value={discretenessName}
              optionType="button"
            />
          </Col>
        </Row>
        <Column {...config} />
      </Space>
    </Card>
  );
};

const discreteness = {
  byDay,
  byWeek,
  byMonth,
};

export default DemoColumn;
